import React, { useContext, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import {
  Grid,
  Button,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import SignatureCanvas from "react-signature-canvas";
import { DownloadIcon } from "lucide-react";
import html2canvas from "html2canvas";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { saveAs } from "file-saver";
import { Tabs, Tab, Card, CardContent } from "@mui/material";
import api from "../../../api/axios";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { Email } from "@mui/icons-material";
import Swal from "sweetalert2";
import { PermissionContext } from "../../../Components/Context/Context";

const FirmaContent = ({
  caseContract,
  flagAcceptReject,
  acceptedContract,
  nextTask,
  rerender = "firma-0",
  activeTask,
  setUpdatedCase,
  updatedCase,
  dataCase,
  usersFlag,
}) => {
  const [signatureMode, setSignatureMode] = useState("canvas");
  const [showSignature, setShowSignature] = useState(false);

  const { can } = useContext(PermissionContext);
  const canSign = can("cases", "signcontract");

  // "", "canvas", "upload"
  // Contract
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
    useState(false);
  const [rejectTermsAndConditions, setRejectTermsAndConditions] =
    useState(false);
  const [marketing, setMarketing] = useState(false);
  const [acceptedHtml, setAcceptedHtml] = useState(acceptedContract);

  // SIGNATURE
  const [signaturePad, setSignaturePad] = useState(null);
  const [signatureImage, setSignatureImage] = useState("");
  const [uploadedSignature, setUploadedSignature] = useState("");

  const canDownload =
    !!caseContract?.firmaUsuario?.firma || // Hay contrato guardado en la BD
    !!signatureImage || // Se dibujó una firma
    !!uploadedSignature; // Se subió una imagen

  // RESEND OTP
  const [email, setEmail] = useState(
    dataCase?.clients_relation?.email ? dataCase?.clients_relation?.email : "",
  );
  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const handleCloseOtpDialog = () => setOpenOtpDialog(false);

  const ContractText = ({ accept, contract }) => {
    // console.log(contract);
    return (
      <div>
        {accept !== "" ? (
          <div dangerouslySetInnerHTML={{ __html: accept }}></div>
        ) : (
          <div>
            <h3
              style={{ textAlign: "center" }}
              dangerouslySetInnerHTML={{ __html: contract.contractTitle }}></h3>
            <hr style={{ marginBottom: "20px" }}></hr>
            <div
              style={{ textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: contract.contract }}
            />
            <hr style={{ marginBottom: "20px", marginTop: "30px" }} />
            <GetTextAcceptContract
              clientName={contract?.contractAcceptData?.client_name ?? ""}
              clientDocument={contract?.contractAcceptData?.client_nif ?? ""}
              companyName={contract?.contractAcceptData?.company_name ?? ""}
              ip={contract?.contractAcceptData?.client_ip ?? ""}
            />
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    setAcceptedHtml(acceptedContract);
  }, [acceptedContract]);

  const GetTextAcceptContract = ({
    clientName,
    clientDocument,
    companyName,
    ip,
  }) => {
    const date = new Date();
    const dateFormatted = `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
    const timeFormatted = `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    return (
      <div>
        <p>
          YO <strong>{clientName}</strong> CON NIF/PASAPORTE{" "}
          <strong>{clientDocument}</strong> ACEPTO EXPRESAMENTE LAS CONDICIONES
          GENERALES DE LA HOJA DE ENCARGO DE <strong>{companyName}</strong>
        </p>
        <p>
          HAGO CONSTAR ESTAR CONFORME CON LAS CONDICIONES DE ESTA HOJA DE
          ENCARGO CON FECHA <strong>{dateFormatted}</strong> A LAS{" "}
          <strong>{timeFormatted}</strong> DESDE LA IP <strong>{ip}</strong>
        </p>
      </div>
    );
  };

  const getContractHTML = () => {
    // console.log("contractAcceptData:", caseContract?.contractAcceptData);

    const htmlString = ReactDOMServer.renderToStaticMarkup(
      <ContractText accept={acceptedHtml} contract={caseContract} />,
    );
    return htmlString;
  };

  const encodeBase64 = (str) => {
    return btoa(unescape(encodeURIComponent(str)));
  };

  const handleAcceptChange = () => {
    setAcceptTermsAndConditions(true);
    setRejectTermsAndConditions(false); // Desmarca y deshabilita "No acepto"
  };

  const handleRejectChange = () => {
    setRejectTermsAndConditions(true);
    setAcceptTermsAndConditions(false); // Desmarca y deshabilita "Acepto"
  };

  // Limpia la firma
  const clearSignature = () => {
    if (signaturePad) signaturePad.clear();

    // Quitar la imagen guardada y reactivar el canvas
    setSignatureImage("");
    setUploadedSignature("");
  };

  const handleContractDecision = () => {
    const contractHtml = getContractHTML();

    // if (
    //   !signatureImage &&
    //   !uploadedSignature &&
    //   !caseContract?.firmaUsuario?.firma_usuario
    // ) {
    //   Swal.fire({
    //     title: "Falta la firma",
    //     text: "Debe firmar o subir una firma para continuar.",
    //     icon: "warning",
    //     confirmButtonColor: "#1ab394",
    //   });
    //   return;
    // }

    if (acceptTermsAndConditions) {
      console.log("Se han aceptado las condiciones");
      const base64 = encodeBase64(contractHtml);
      let dataURL;

      if (caseContract?.firmaUsuario?.firma_usuario) {
        dataURL = caseContract?.firmaUsuario?.firma_usuario;
      } else {
        if (!signaturePad || signaturePad.isEmpty()) {
          dataURL = "";
        } else {
          dataURL = signaturePad.getCanvas().toDataURL("image/png");
        }
      }

      const config = {
        firma: base64,
        firma_usuario: dataURL ?? "",
      };

      // console.log(contractHtml);

      Swal.fire({
        title: "¿Estás seguro que deseas aceptar la firma?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Sí",
        denyButtonText: "Volver",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // NEXT TASK
          nextTask(config, 1, "next", "");
        }
      });
    } else if (rejectTermsAndConditions) {
      console.log("Se han rechazado las condiciones");
      nextTask({}, 2, true, "");
    } else {
      Swal.fire({
        title: "¡Error!",
        text: "Por favor marque la casilla",
        icon: "warning",
        showDenyButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    }
  };

  // Guarda la firma como Base64
  const saveSignature = async (flag) => {
    // console.log(flag);
    // console.log(acceptedHtml);

    if (!signaturePad || signaturePad.isEmpty()) {
      Swal.fire({
        title: "Sin firma",
        text: "Por favor realiza la firma antes de continuar.",
        icon: "warning",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    let dataURL;

    if (!signaturePad || signaturePad.isEmpty()) {
      dataURL = "";
    } else {
      dataURL = signaturePad.getCanvas().toDataURL("image/png");
    }

    if (acceptedHtml && dataURL && flag == "signed") {
      console.log("Entro a guardar la firma");

      try {
        // 🔵 Mostrar Swal de carga
        Swal.fire({
          title: "Guardando...",
          text: "Por favor espera",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const base64 = encodeBase64(acceptedHtml);

        const config = {
          firma: base64,
          firma_usuario: dataURL ?? "",
        };

        // Crear formData
        const formDataTask = new FormData();
        formDataTask.append("current_task", activeTask?.id || "");
        formDataTask.append("config", JSON.stringify(config));

        const url = `${process.env.REACT_APP_API_URL}/casestasks/updatetasks`;

        // 🔵 Enviar al backend
        const responseTaskUpdated = await api.post(url, formDataTask);

        setSignatureImage(dataURL);
        setUploadedSignature(dataURL); // <--- este hace que se muestre la imagen y se oculte el canvas

        // 🔵 Cerrar loading
        Swal.close();

        // 🔵 Mostrar éxito
        Swal.fire({
          title: "Guardado",
          text: "La firma se ha guardado en el documento exitosamente.",
          icon: "success",
          confirmButtonColor: "#1ab394",
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then(() => {
          console.log("Log");

          setUpdatedCase(!updatedCase);
        });
      } catch (error) {
        console.error(error);

        // Cerrar loading en caso de error
        Swal.close();

        Swal.fire({
          title: "Error",
          text: "No se pudo guardar la firma. Intenta nuevamente.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    } else {
      setSignatureImage(dataURL);
      setUploadedSignature(dataURL); // <--- este hace que se muestre la imagen y se oculte el canvas

      Swal.fire({
        title: "Firma guardada",
        text: "Puede continuar con el proceso.",
        icon: "success",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  const downloadContract = async () => {
    Swal.fire({
      title: "Generando PDF...",
      text: "Por favor espera un momento",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      //  Generar el HTML final del contrato EXACTAMENTE como ya lo tienes
      let htmlContent = "";

      if (caseContract?.firmaUsuario?.firma) {
        const decoded = decodeURIComponent(
          escape(atob(caseContract.firmaUsuario.firma)),
        );
        htmlContent = decoded;
      } else {
        htmlContent = getContractHTML();
      }

      const finalSignature =
        signatureImage ||
        (caseContract?.firmaUsuario?.firma_usuario &&
          caseContract?.firmaUsuario?.firma_usuario != "")
          ? caseContract?.firmaUsuario?.firma_usuario
          : null;

      const finalHtml = `
      <div id="pdf-content" style="padding:20px; font-family:Arial;">
        ${htmlContent}
        <hr style="margin:20px 0;" />
        <h3>Firma del cliente:</h3>
        ${
          finalSignature
            ? `<img src="${finalSignature}" style="width:300px;height:120px;object-fit:contain;border:1px solid #ccc"/>`
            : "<p><i>No se registró firma.</i></p>"
        }
      </div>
    `;

      //  Convertir el HTML a un nodo temporal para capturarlo
      const temp = document.createElement("div");
      temp.innerHTML = finalHtml;
      temp.style.position = "fixed";
      temp.style.top = "-9999px";
      document.body.appendChild(temp);

      //  Capturar con html2canvas
      const canvas = await html2canvas(temp, {
        scale: 2,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      //  Crear PDF con pdf-lib
      const pxToPt = (px) => (px * 72) / 96;

      const pdfWidth = pxToPt(canvas.width);
      const pdfHeight = pxToPt(canvas.height);

      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([pdfWidth, pdfHeight]);

      const pngImage = await pdfDoc.embedPng(imgData);

      page.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: pdfWidth,
        height: pdfHeight,
      });

      const pdfBytes = await pdfDoc.save();

      //  Descargar PDF real
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      saveAs(
        blob,
        `Contrato-${
          caseContract?.contractAcceptData?.client_name ?? "cliente"
        }.pdf`,
      );

      document.body.removeChild(temp);

      Swal.fire({
        icon: "success",
        title: "PDF generado",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error al generar el PDF",
        text: e.message,
      });
    }
  };

  const sendOtp = async () => {
    console.log("Enviando OTP a:", email);

    // Usar Swal.showLoading() para mostrar el loading
    Swal.fire({
      title: "Enviando código...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    console.log("dataCase", dataCase);

    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/send-otp-client`,
        {
          email,
          case_id: dataCase?.id,
        },
      );
      console.log("   Respuesta send-otp:", res.data);

      Swal.fire(
        "Código enviado",
        "El código ha sido enviado a correo del cliente",
        "success",
      );
    } catch (e) {
      console.error("Error enviando OTP:", e);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          e?.response?.data?.message ||
          "No se pudo enviar el código. Verifica el correo.",
      });
    } finally {
      // Cerrar el loading
      // Swal.close();
      handleCloseOtpDialog();
    }
  };

  const handleSend = () => {
    if (!email) return;
    sendOtp(email);
  };

  useEffect(() => {
    const savedSignature = caseContract?.firmaUsuario?.firma_usuario;

    // Si viene firma desde la BD → cargarla
    if (savedSignature && savedSignature !== "") {
      setUploadedSignature(savedSignature);
      setSignatureImage(savedSignature);
      setSignatureMode("canvas");
      return;
    }

    // Si NO viene firma desde la BD pero ya hay una en memoria → NO tocar nada
    if (signatureImage || uploadedSignature) {
      setSignatureMode("canvas");
      return;
    }

    // Si NO hay nada → inicializar en modo canvas sin borrar estados manualmente
    setSignatureMode("canvas");
  }, [caseContract]);

  return (
    // <Box>
    <Box key={rerender}>
      {usersFlag && (
        <Box
          sx={{ marginBottom: "20px", display: "flex", justifyContent: "end" }}>
          <CustomButtonPlusIcon
            variant="contained"
            color="success"
            position="end"
            size="small"
            icon={Email}
            handleFunction={() => setOpenOtpDialog(true)}
            text={"Reenviar código de verificación al cliente"}
          />
        </Box>
      )}

      <Dialog
        open={openOtpDialog}
        onClose={handleCloseOtpDialog}
        maxWidth="xs"
        fullWidth>
        <DialogTitle>Reenviar código</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Correo electrónico del cliente"
            type="email"
            fullWidth
            size="small"
            disabled={true}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </DialogContent>

        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button onClick={handleCloseOtpDialog} color="error" size="small">
            Cancelar
          </Button>

          <Button
            onClick={handleSend}
            variant="contained"
            color="primary"
            size="small"
            disabled={!email}>
            Reenviar código
          </Button>
        </DialogActions>
      </Dialog>

      <ContractText accept={acceptedHtml} contract={caseContract} />
      <Button
        variant="contained"
        color={showSignature ? "error" : "success"}
        onClick={() => setShowSignature((prev) => !prev)}
        sx={{ mb: 2 }}>
        {showSignature
          ? "Ocultar subir firma"
          : "Subir o dibujar firma (OPCIONAL)"}
      </Button>

      <Box sx={{ margin: "20px 0", textAlign: "center" }}>
        <Collapse in={showSignature} timeout={400}>
          <Box>
            <h3>Firma</h3>

            {/* ===================== OPCIONES ===================== */}
            <Card sx={{ maxWidth: 600, margin: "0 auto", borderRadius: 3 }}>
              {acceptedHtml && caseContract?.firmaUsuario?.firma_usuario ? (
                <></>
              ) : (
                <Tabs
                  value={signatureMode}
                  onChange={(e, val) => setSignatureMode(val)}
                  centered
                  sx={{ borderBottom: "1px solid #ddd" }}>
                  <Tab
                    value="canvas"
                    label="Dibujar firma"
                    disabled={!!uploadedSignature}
                  />
                  <Tab
                    value="upload"
                    label="Subir PNG"
                    disabled={!!uploadedSignature}
                  />
                </Tabs>
              )}

              <CardContent>
                {!signatureMode && (
                  <p style={{ margin: "20px 0" }}>
                    Seleccione una opción para continuar.
                  </p>
                )}

                {signatureMode === "canvas" && (
                  <>
                    {uploadedSignature ? (
                      <img
                        src={uploadedSignature}
                        alt="Firma del cliente"
                        style={{
                          width: "500px",
                          height: "200px",
                          objectFit: "contain",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          background: "#fff",
                        }}
                      />
                    ) : (
                      <SignatureCanvas
                        penColor="black"
                        canvasProps={{
                          width: 500,
                          height: 200,
                          className: "sigCanvas",
                          style: {
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            marginTop: "10px",
                          },
                        }}
                        ref={(ref) => setSignaturePad(ref)}
                      />
                    )}

                    {!uploadedSignature && (
                      <Box
                        sx={{
                          marginTop: "15px",
                          display: "flex",
                          justifyContent: "center",
                          gap: "12px",
                        }}>
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={clearSignature}>
                          Limpiar
                        </Button>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() =>
                            acceptedHtml
                              ? saveSignature("signed")
                              : saveSignature("unsinged")
                          }>
                          Guardar firma
                        </Button>
                      </Box>
                    )}
                  </>
                )}

                {signatureMode === "upload" && (
                  <div>
                    <p>Cargar archivo de firma (formato PNG)</p>

                    <input
                      id="upload-signature"
                      type="file"
                      accept="image/png"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        if (file.type !== "image/png") {
                          Swal.fire({
                            title: "Formato incorrecto",
                            text: "Solo se permiten imágenes PNG.",
                            icon: "error",
                            confirmButtonColor: "#1ab394",
                          });
                          return;
                        }

                        if (file.size > 2 * 1024 * 1024) {
                          Swal.fire({
                            title: "Archivo demasiado grande",
                            text: "Máximo 2MB.",
                            icon: "warning",
                            confirmButtonColor: "#1ab394",
                          });
                          return;
                        }

                        const reader = new FileReader();
                        reader.onload = (ev) => {
                          const imgBase64 = ev.target.result;
                          setUploadedSignature(imgBase64);
                          setSignatureImage(imgBase64);

                          if (signaturePad) signaturePad.clear();
                          e.target.value = "";
                        };
                        reader.readAsDataURL(file);
                      }}
                    />

                    <Box
                      sx={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                        gap: "12px",
                      }}>
                      <Button
                        variant="outlined"
                        onClick={() =>
                          document.getElementById("upload-signature").click()
                        }>
                        Subir archivo PNG
                      </Button>

                      {uploadedSignature && (
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={() => {
                            setUploadedSignature("");
                            setSignatureImage("");
                            const input =
                              document.getElementById("upload-signature");
                            if (input) input.value = "";
                          }}>
                          Quitar imagen
                        </Button>
                      )}
                    </Box>

                    {uploadedSignature && (
                      <img
                        src={uploadedSignature}
                        alt="Firma subida"
                        style={{
                          marginTop: "15px",
                          width: "500px",
                          height: "200px",
                          objectFit: "contain",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          background: "#fff",
                        }}
                      />
                    )}
                  </div>
                )}
              </CardContent>
            </Card>
          </Box>
        </Collapse>

        {/* ===================== BOTÓN DESCARGAR ===================== */}
        {caseContract?.contractAcceptData?.client_name && (
          <Box sx={{ marginTop: "25px", textAlign: "end" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={downloadContract}
              startIcon={<DownloadIcon />}
              disabled={!canDownload}>
              Descargar documento completo
            </Button>
          </Box>
        )}
      </Box>

      <FormControl component="fieldset" sx={{ textAlign: "center" }}>
        <FormGroup
          aria-label="position"
          row
          sx={{
            alignItems: "center",
            textAlign: "center",
            marginBottom: "10px",
          }}>
          {/* {console.log(flagAcceptReject)} */}
          {flagAcceptReject && canSign && (
            <Grid container item xs={12}>
              <Grid item xs={12} className="alignItemsAndCenter">
                <FormControlLabel
                  className="formControlLabelCss"
                  control={
                    <Checkbox
                      id="shortSuccess"
                      className="caseCheckBox"
                      checked={marketing}
                    />
                  }
                  label="Acepto el uso de mi correo electrónico para el envío de comunicaciones con fines informativos y comerciales."
                  onChange={() => setMarketing(!marketing)}
                  labelPlacement="end"
                  sx={{ textAlign: "left" }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                className="alignItemsAndCenter"
                sx={{ paddingRight: "10px" }}>
                <FormControlLabel
                  className="formControlLabelCss"
                  control={
                    <Checkbox
                      checked={rejectTermsAndConditions}
                      onClick={handleRejectChange}
                      // disabled={acceptTermsAndConditions} // Deshabilita si "Acepto" está seleccionado
                      className="caseCheckBox"
                      color="error"
                    />
                  }
                  label="He leído y NO acepto las condiciones"
                  labelPlacement="end"
                  sx={{ textAlign: "left" }}
                />
                <Button
                  onClick={handleContractDecision}
                  disabled={acceptTermsAndConditions}
                  variant="contained"
                  color="error"
                  size="small">
                  Rechazar
                </Button>
              </Grid>
              <Grid
                item
                xs={6}
                className="alignItemsAndCenter"
                justifyContent={"right"}>
                <FormControlLabel
                  className="formControlLabelCss"
                  control={
                    <Checkbox
                      checked={acceptTermsAndConditions}
                      color="success"
                      onClick={handleAcceptChange}
                      // disabled={rejectTermsAndConditions} // Deshabilita si "No acepto" está seleccionado
                      className="caseCheckBox"
                    />
                  }
                  label="He leído y acepto las condiciones"
                  labelPlacement="end"
                  sx={{ textAlign: "left" }}
                />
                <Button
                  onClick={handleContractDecision}
                  disabled={rejectTermsAndConditions}
                  variant="contained"
                  color="success"
                  size="small">
                  Aceptar
                </Button>
              </Grid>
            </Grid>
          )}
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default FirmaContent;
